import { withStyles } from '@material-ui/core/styles';
import { makeStyles, Theme } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { Palette } from '@material-ui/core/styles/createPalette';

type ThemePaletteKey = keyof Pick<
  Palette,
  'persimmon' | 'sunglow' | 'sanMarino' | 'minsk' | 'monaco' | 'pyrenean' | 'alps' | 'highlands'
>;

const themeList: ThemePaletteKey[] = [
  'persimmon',
  'sunglow',
  'sanMarino',
  'minsk',
  'monaco',
  'pyrenean',
  'alps',
  'highlands',
];

interface StyleProps {
  index: number;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  categoryTitle: {
    margin: 0,
  },

  wrapper: ({ index }) => {
    const paletteKey = themeList[index % themeList.length];
    const selectedTheme = theme.palette[paletteKey];

    return {
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none',
      backgroundColor: selectedTheme.light,
      color: selectedTheme.dark,
      padding: theme.spacing(1),
    };
  },

  buttonContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: 5,
  },

  button: {
    height: 30,
    lineHeight: 1.15,
    fontSize: theme.typography.pxToRem(12),
    textTransform: 'none',
    '&>span': {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      wordBreak: 'break-word',
      overflow: 'hidden',
    },
  },

  buttonColor: ({ index }) => {
    const paletteKey = themeList[index % themeList.length];
    const selectedTheme = theme.palette[paletteKey];

    return {
      backgroundColor: selectedTheme.dark,
      color: selectedTheme.contrastText,
      '&:hover': {
        backgroundColor: selectedTheme.main,
      },
    };
  },

  buttonGrey: {
    backgroundColor: theme.palette.grey['500'],
    color: theme.palette.grey['900'],
    '&:hover': {
      backgroundColor: theme.palette.grey['100'],
    },
  },
}));

export const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    userSelect: 'none',
    maxWidth: 500,
    padding: 0,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.pxToRem(12),
  },
}))(Tooltip);
